/*
 * UpdateUsername Messages
 *
 * This contains all the text for the UpdateUsername component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.UpdateUsername";

export default defineMessages(scope, {
  username: "Username",
  usernameRequirements: "Username requirements",
  usernamePlaceholder: "Enter your username",

  // rules
  unique: "Must be unique",
  length: "Must be between 5-100 characters",
  begin: "Must begin with letter or number",
  allowedCharacters: "Allowed: letters, numbers, and symbols: - _ . @ $ +",

  validationError: "Must be 5–100 characters and use supported symbols only",
  duplicateError: "This username is already in use",
  requiredError: "This field is required!",
  unchangedError: "Your new username cannot be the same as your old username.",
});
